module.exports = __webpack_public_path__ + "static/cosypgiraffemain-3bbdbfeb3c0a4e2ffb5ae861d44b81bb.jpeg";